// extracted by mini-css-extract-plugin
module.exports = {"biblio":"Biblio_biblio__2YqtU","biblio__list-item":"Biblio_biblio__list-item__2V6hC","biblio__list-item-body":"Biblio_biblio__list-item-body__3qQoO"};